import { useEffect } from 'react';
import { X } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

interface GuidePanelProps {
  markdown: string;
  onClose: () => void;
}

export default function GuidePanel({ markdown, onClose }: GuidePanelProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="h-full p-6 relative overflow-y-auto">
      <button
        onClick={onClose}
        title="Close"
        className="absolute top-2 right-2 p-1"
      >
        <X size={20} />
      </button>
      <div className="mt-6 text prose max-w-none">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
        >{markdown}</ReactMarkdown>
      </div>
    </div>
  );
}
